import React from 'react';
import moment from 'moment';
import numeral from 'numeral';
import { withRouter } from 'react-router-dom';
import { AgGridColumn } from '@ag-grid-community/react';
import DataGrid from '../../common/components/DataGrid';

const money = ({ colDef, data }) => {
  const v = data[colDef.field];
  if (v || v === 0) {
    return numeral(v).format('$0,0.[00]');
  }
};

const hours = ({ colDef, data }) => {
  const v = data[colDef.field];
  if (v || v === 0) {
    return numeral(v).format('0,0.[00]');
  }
};

const percent = ({ colDef, data }) => {
  const v = data[colDef.field];
  if (v || v === 0) {
    return numeral(v).format('0.[00]%');
  }
};

// Keep export values clean and computable in Excel: round numbers to 2 decimals
// (no float tails, no $/comma) and render the completion date as MM/DD/YYYY.
const exportProcessCellCallback = ({ value, column }) => {
  if (value == null || value === '') {
    return '';
  }
  if (column.getColId() === 'estimatedEndDate') {
    // Format in UTC: the Date scalar serializes to epoch-ms at UTC midnight, so
    // local formatting would shift the calendar date back a day west of UTC.
    return moment.utc(value).isValid() ? moment.utc(value).format('MM/DD/YYYY') : '';
  }
  if (typeof value === 'number') {
    return Number(value.toFixed(2));
  }
  return value;
};

class WipReportGrid extends React.Component {
  render() {
    const { rowData = [], onExportReady, history } = this.props;
    return (
      <DataGrid
        rowData={rowData}
        onExportReady={onExportReady}
        exportProcessCellCallback={exportProcessCellCallback}
        exportFileName={`WIP-ExportedOn(${moment(new Date()).format('YYYYMMDD-HHmm')}).csv`}
      >
        <AgGridColumn
          field="name"
          headerName="Project Description"
          width={400}
          cellStyle={{ color: '#2563eb', cursor: 'pointer', textDecoration: 'underline' }}
          onCellClicked={({ data }) => {
            if (data?._id) {
              history.push(`/finance/projects/${data._id}`);
            }
          }}
        />
        <AgGridColumn field="budget" headerName="Contract Price" valueFormatter={money} />
        <AgGridColumn field="totalApprovedHours" headerName="Actual Hours Worked" valueFormatter={hours} />
        <AgGridColumn field="monthToDateHours" headerName="Month To Date" valueFormatter={hours} />
        <AgGridColumn field="actualHoursRemaining" headerName="Actual Hours Remaining" valueFormatter={hours} />
        <AgGridColumn field="totalHours" headerName="Total Hours" valueFormatter={hours} />
        <AgGridColumn field="percentComplete" headerName="% Complete" valueFormatter={percent} />
        <AgGridColumn
          field="estimatedEndDate"
          headerName="Date of Completion"
          valueFormatter={({ colDef, data }) => {
            const v = data[colDef.field];
            return v ? moment.utc(v).format('MM/DD/YYYY') : '';
          }}
        />
        <AgGridColumn field="totalBilledAmount" headerName="Billed To Date" valueFormatter={money} />
        <AgGridColumn field="incomeRecognized" headerName="Income Recognized" valueFormatter={money} />
        <AgGridColumn field="backlog" headerName="Backlog" valueFormatter={money} />
        <AgGridColumn field="overUnderBilled" headerName="Over/Under Billed" valueFormatter={money} />
        <AgGridColumn field="owner" headerName="Project Managers" width={160} />
      </DataGrid>
    );
  }
}

export default withRouter(WipReportGrid);
